import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "guide-skeleton"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    class: "mt-8 sectionBlocksWrapper",
    style: { "bottom": "170px" }
};
import { getCurrentInstance, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import ArticleList from './elements/ArticleList.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import GuideSectionButton from './elements/GuideSectionButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GuidePage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getPlan, getCmsArticles } = useContent();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        function peekingDrawerBottomNoMenu() {
            const ret = -10;
            return ret + 'px';
        }
        function closedDrawerHeightNoMenu() {
            return (60 + (cookies?.get('sb') ? parseInt(cookies.get('sb')) : 0)) + 'px';
        }
        function onLoad() {
            getCustomer();
            getPlan(route.params.id, () => {
                console.log(state.plan.tags, 'Getting articles for tags');
                getCmsArticles(state.plan.tags);
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_slide_group = _resolveComponent("v-slide-group");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Guide to your finances" }),
                (!_unref(state).plan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_skeleton_loader, {
                            type: "heading",
                            class: "guide-skeleton-item"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            type: "text",
                            class: "guide-skeleton-item"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            type: "paragraph",
                            class: "guide-skeleton-item"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                            type: "image",
                            class: "guide-skeleton-item"
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).plan)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).plan.title), 1),
                                _createElementVNode("h2", null, _toDisplayString(_unref(state).plan.tagLine), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(state).plan.description), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Recommended for you", -1)),
                                    _createVNode(_component_v_slide_group, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).plan.sections, (s) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: "sectionBlock",
                                                    key: s.id
                                                }, [
                                                    _createVNode(GuideSectionButton, { section: s }, null, 8, ["section"])
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(DrawerPanel, {
                    openHeight: "88%",
                    closedHeight: closedDrawerHeightNoMenu(),
                    bottom: peekingDrawerBottomNoMenu(),
                    backgroundColor: "white",
                    openBackgroundColor: "white",
                    title: "Helpful Guides"
                }, {
                    default: _withCtx(() => [
                        _createVNode(ArticleList, {
                            articles: _unref(state).articles
                        }, null, 8, ["articles"])
                    ]),
                    _: 1
                }, 8, ["closedHeight", "bottom"])
            ], 64));
        };
    }
});
